module.exports = __webpack_public_path__ + "33a2122adcb1d83a3ddac036db450d0d.svg";